// Persistance sessionStorage des tokens d'authentification. Choix assume pour MVP-1.C :
// - Pas de localStorage : un token persistant elargit la fenetre XSS au-dela de la session navigateur.
// - Pas de in-memory strict : un F5 sur /welcome perdrait la session et forcerait un re-login Cognito.
// - sessionStorage : compromis pragmatique pour SPA static (pas de cookie httpOnly possible cote
//   client), tokens perdus a la fermeture de l'onglet, multi-onglets gere nativement.
//
// Cf. .claude/rules/frontend-security.md pour la justification complete.

import type { AuthSession } from './auth-provider';

const KEYS = {
  accessToken: 'rmf:auth:access_token',
  refreshToken: 'rmf:auth:refresh_token',
  expiresAt: 'rmf:auth:expires_at',
  user: 'rmf:auth:user'
} as const;

export function persistSession(session: AuthSession): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(KEYS.accessToken, session.accessToken);
  sessionStorage.setItem(KEYS.refreshToken, session.refreshToken);
  sessionStorage.setItem(KEYS.expiresAt, String(session.expiresAt));
  sessionStorage.setItem(KEYS.user, JSON.stringify(session.user));
}

export function readSession(): AuthSession | null {
  if (typeof sessionStorage === 'undefined') return null;
  const accessToken = sessionStorage.getItem(KEYS.accessToken);
  const refreshToken = sessionStorage.getItem(KEYS.refreshToken);
  const expiresAt = sessionStorage.getItem(KEYS.expiresAt);
  const userRaw = sessionStorage.getItem(KEYS.user);
  if (!accessToken || !refreshToken || !expiresAt || !userRaw) return null;
  try {
    return {
      accessToken,
      refreshToken,
      expiresAt: Number(expiresAt),
      user: JSON.parse(userRaw)
    };
  } catch {
    // JSON corrompu (utilisateur a edite le storage manuellement, migration ratee, etc.) :
    // on purge et on retourne null pour forcer une re-auth propre plutot que de planter.
    clearSession();
    return null;
  }
}

export function clearSession(): void {
  if (typeof sessionStorage === 'undefined') return;
  for (const key of Object.values(KEYS)) sessionStorage.removeItem(key);
}
